import React, { ReactElement, ReactNode } from 'react';

import { SafeWalletDialog } from 'modules/auth/components/SafeWalletDialog';
import { SuccessDialog } from 'modules/common/components/SuccessDialog';
import { featureConfig } from 'modules/common/featureConfig';
import { useScrollToTop } from 'modules/common/hooks/useScrollToTop';
import { DelegateDialog } from 'modules/delegate/components/DelegateDialog';
import { ClaimSuccessContent } from 'modules/delegateStaking/components/ClaimSuccessContent';
import { LazyTestLink } from 'modules/dev';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Footer } from 'modules/layout/components/Footer';
import { TabsDialog } from 'modules/liquidStaking/components/TabsDialog';
import { WithdrawDialog } from 'modules/withdraw/components/WithdrawDialog';

import { Header } from '../Header';
import { useStyles } from './useStyles';

interface ILayoutProps {
  children: ReactElement | ReactNode;
}

export function Layout({ children }: ILayoutProps): ReactElement {
  useScrollToTop();
  const { classes } = useStyles();

  const { isOpened: isLsTabsOpened } = useDialog(KnownDialogs.lsTabsDialog);

  const { isOpened: isDelegateOpened } = useDialog<string>(
    KnownDialogs.delegate,
  );

  const { isOpened: isWithdrawOpened } = useDialog<string>(
    KnownDialogs.withdraw,
  );

  const { isOpened: isClaimSuccessOpened, onClose } = useDialog(
    KnownDialogs.claimSuccess,
  );

  return (
    <div className={classes.root}>
      <Footer />

      <div className={classes.content}>{children}</div>

      <Header />

      {isLsTabsOpened && <TabsDialog />}

      {isDelegateOpened && <DelegateDialog />}

      {isWithdrawOpened && <WithdrawDialog />}

      <SafeWalletDialog />

      {isClaimSuccessOpened && (
        <SuccessDialog type={KnownDialogs.claimSuccess}>
          <ClaimSuccessContent onClose={onClose} />
        </SuccessDialog>
      )}

      {featureConfig.isDevUiEnabled && <LazyTestLink />}
    </div>
  );
}
